exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "sup.notification-count[data-v-2ee0a246]{font-size:.75em;margin-top:-10px}div.notification-list[data-v-2ee0a246]{width:300px;overflow-x:hidden;max-height:400px;overflow-y:auto}p.is-notification[data-v-2ee0a246]{white-space:normal;width:268px;overflow-x:hidden}.navbar-link[data-v-2ee0a246]:after{-webkit-transform:rotate(135deg);transform:rotate(135deg);-webkit-transition:-webkit-transform .3s ease;transition:-webkit-transform .3s ease;transition:transform .3s ease;transition:transform .3s ease,-webkit-transform .3s ease}.navbar-link.rotate[data-v-2ee0a246]:after{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ee0a246","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/core/structure/navbar/Notifications.vue
// module id = b7DO
// module chunks = 66